import React from 'react';
import { Chip, createTheme, ThemeProvider } from '@mui/material';
import styles from './PreferenceTypeOne.module.scss';
import colors from '../../../../scss/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.PRIMARY_BLUE
    }
  },
  color: colors.WHITE
});

export function PreferenceTypeOne({ fields }) {
  return (
    <div className={styles.PreferenceParent}>
      <div className={styles.preferenceList}>
        {fields?.length !== 0 ? (
          fields?.map((item) => {
            const { skillName, id } = item;
            return (
              <ThemeProvider key={id} theme={theme}>
                <Chip
                  label={skillName}
                  color="primary"
                  variant="filled"
                  sx={{ color: colors.WHITE, fontFamily: 'Gotham-Book' }}
                />
              </ThemeProvider>
            );
          })
        ) : (
          <div className={styles.noPreferenceMSG}>No Skills preference Selected</div>
        )}
      </div>
    </div>
  );
}
